// Mapa de rank para os valores de `freelancer.tempo_experiencia` (texto livre,
// proveniente do formulário JotForm). Usado para ordenar/comparar experiência.

export const EXPERIENCIA_RANK: Record<string, number> = {
  "Sem experiência": 0,
  "Menos de 1 ano": 1,
  "Entre 1 e 3 anos": 2,
  "Entre 3 e 6 anos": 3,
  "Entre 6 e 10 anos": 4,
  "Acima de 10 anos": 5,
};

export function rankExperiencia(value?: string | null): number | null {
  if (!value) return null;
  const rank = EXPERIENCIA_RANK[value.trim()];
  return typeof rank === "number" ? rank : null;
}
